(function () {
  'use strict';
  if (window.__d1DeliveryEstimateScriptLoaded) return;
  window.__d1DeliveryEstimateScriptLoaded = true;

  var DEFAULT_ETA_API = 'https://d1x.d1store.app/api/public/delivery-eta';
  var DEFAULT_STOCK_API = 'https://d1x.d1store.app/api/public/store-pickup-stock';
  var WAREHOUSE_DISPATCH_HOURS = 24;
  var STORE_DISPATCH_HOURS = 48;
  var WAREHOUSE_MODAL_NOTE =
    'Estimates based on dispatch from Brunswick (Melbourne). Actual delivery may vary.';
  var STORE_MODAL_NOTE =
    'Estimates include extra dispatch time from a D1 retail store. Actual delivery may vary.';
  // v2: express single-day ETAs get a +1 business-day buffer in the UI
  var CACHE_PREFIX = 'd1_eta_v2:';
  var boundModal = null;
  var modalAbortController = null;
  var inventoryObserver = null;
  var initGeneration = 0;

  var ZONES = [
    { min: 3000, max: 3207, label: 'Melbourne Metro', standard: [2, 4], express: [1, 2] },
    { min: 3208, max: 3999, label: 'VIC Regional', standard: [3, 5], express: [2, 3] },
    { min: 8000, max: 8999, label: 'VIC PO Boxes', standard: [3, 5], express: [2, 3] },
    { min: 2600, max: 2620, label: 'ACT', standard: [3, 5], express: [2, 3] },
    { min: 2000, max: 2249, label: 'Sydney Metro', standard: [3, 5], express: [2, 3] },
    { min: 2250, max: 2599, label: 'NSW Regional', standard: [4, 7], express: [3, 4] },
    { min: 2621, max: 2999, label: 'NSW Regional', standard: [4, 7], express: [3, 4] },
    { min: 4000, max: 4399, label: 'Brisbane / SEQ', standard: [4, 7], express: [3, 4] },
    { min: 4400, max: 4999, label: 'QLD Regional', standard: [5, 9], express: [4, 6] },
    { min: 9000, max: 9999, label: 'QLD PO Boxes', standard: [5, 9], express: [4, 6] },
    { min: 5000, max: 5199, label: 'Adelaide Metro', standard: [4, 6], express: [3, 4] },
    { min: 5200, max: 5999, label: 'SA Regional', standard: [5, 8], express: [4, 5] },
    { min: 6000, max: 6199, label: 'Perth Metro', standard: [6, 9], express: [5, 7] },
    { min: 6200, max: 6999, label: 'WA Regional', standard: [8, 12], express: [4, 6] },
    { min: 7000, max: 7999, label: 'Tasmania', standard: [4, 7], express: [3, 5] },
    { min: 800, max: 999, label: 'NT', standard: [6, 10], express: [5, 7] }
  ];

  function normalizePostcode(value) {
    if (!value) return '';
    return String(value).replace(/\D/g, '').slice(0, 4);
  }

  function lookupZone(postcode) {
    var pc = parseInt(postcode, 10);
    if (isNaN(pc)) return null;
    for (var i = 0; i < ZONES.length; i++) {
      if (pc >= ZONES[i].min && pc <= ZONES[i].max) return ZONES[i];
    }
    return null;
  }

  function addBusinessDays(start, days) {
    var d = new Date(start);
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0 && d.getDay() !== 6) added++;
    }
    return d;
  }

  function fmtDate(d) {
    var days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return days[d.getDay()] + ' ' + d.getDate() + ' ' + months[d.getMonth()];
  }

  function parseIsoDate(iso) {
    if (!iso || typeof iso !== 'string') return null;
    var parts = iso.split('-');
    if (parts.length !== 3) return null;
    var d = new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]));
    if (isNaN(d.getTime())) return null;
    return d;
  }

  function fmtIsoDate(iso) {
    var d = parseIsoDate(iso);
    return d ? fmtDate(d) : '';
  }

  // ponytail: AusPost often returns a single express day — show through next business day as buffer
  function withExpressBuffer(fromIso, toIso) {
    var from = fromIso || toIso || '';
    var to = toIso || fromIso || '';
    if (!from) return { from: '', to: '' };
    if (!to || to === from) {
      var start = parseIsoDate(from);
      if (start) {
        var next = addBusinessDays(start, 1);
        to =
          next.getFullYear() +
          '-' +
          String(next.getMonth() + 1).padStart(2, '0') +
          '-' +
          String(next.getDate()).padStart(2, '0');
      }
    }
    return { from: from, to: to };
  }

  function cacheDayKey() {
    var now = new Date();
    return (
      now.getFullYear() +
      '-' +
      String(now.getMonth() + 1).padStart(2, '0') +
      '-' +
      String(now.getDate()).padStart(2, '0')
    );
  }

  function getDeliveryContainer() {
    return document.querySelector('[data-d1-delivery-details]');
  }

  function getPostcodePrompt() {
    return document.querySelector('[data-d1-postcode-prompt]');
  }

  function setDeliveryCardEta(container, hasEta) {
    var card = container && container.closest('.d1-delivery');
    if (card) card.classList.toggle('d1-delivery--has-eta', hasEta);
    var prompt = getPostcodePrompt();
    if (!prompt) return;
    prompt.hidden = hasEta;
    if (container) container.hidden = !hasEta;
  }

  function setResolvedPostcode(container, postcode) {
    if (!container) return;
    var clean = normalizePostcode(postcode);
    if (/^\d{4}$/.test(clean)) {
      container.setAttribute('data-d1-resolved-postcode', clean);
    } else {
      container.removeAttribute('data-d1-resolved-postcode');
    }
  }

  function isPreorderDeliveryActive() {
    var submit = document.querySelector('[data-d1-main-submit]');
    if (submit && submit.getAttribute('data-preorder') === 'true') return true;
    if (submit && submit.getAttribute('data-backorder') === 'true') return true;
    var delivery = document.querySelector('[id^="Delivery-"]');
    if (!delivery) return false;
    if (delivery.getAttribute('data-preorder') === 'true') return true;
    if (delivery.getAttribute('data-backorder') === 'true') return true;
    return Boolean(
      delivery.querySelector('[data-d1-preorder-delivery], [data-d1-backorder-delivery]')
    );
  }

  function getEtaApiBase() {
    var el = getDeliveryContainer();
    var fromDom = el && el.getAttribute('data-eta-api');
    return (fromDom && fromDom.trim()) || DEFAULT_ETA_API;
  }

  function isBrunswickName(name) {
    var n = String(name || '').trim().toLowerCase();
    return n === 'brunswick' || n.indexOf('brunswick') !== -1;
  }

  function isInStockStatus(status) {
    return status === 'available' || status === 'low';
  }

  // warehouse = BRU has it; store = BRU empty but another location has it; unknown = leave as-is
  function classifyDispatchOrigin(locations) {
    if (!locations || !locations.length) return 'unknown';
    var bru = null;
    var storeInStock = false;
    for (var i = 0; i < locations.length; i++) {
      var loc = locations[i];
      if (!loc) continue;
      if (isBrunswickName(loc.name)) {
        bru = loc;
        continue;
      }
      if (isInStockStatus(loc.status)) storeInStock = true;
    }
    if (!bru) return 'unknown';
    if (isInStockStatus(bru.status)) return 'warehouse';
    if (storeInStock) return 'store';
    return 'unknown';
  }

  function dispatchDaysFromHours(hours) {
    var n = parseInt(hours, 10);
    if (!Number.isFinite(n) || n <= 0) return 1;
    // 24 = warehouse wave + 1 extra day; 48 = store origin (+1 more business day)
    if (n >= STORE_DISPATCH_HOURS) return 3;
    if (n >= WAREHOUSE_DISPATCH_HOURS) return 2;
    return 1;
  }

  function getDispatchDays() {
    var el = getDeliveryContainer();
    if (el && el.getAttribute('data-dispatch-hours')) {
      return dispatchDaysFromHours(el.getAttribute('data-dispatch-hours'));
    }
    var btn = document.querySelector('.product__inventory-btn');
    if (btn && btn.classList.contains('product__inventory--low')) return 2;
    return 1;
  }

  function canApplyStoreOrigin() {
    return Boolean(document.querySelector('product-info [data-d1-delivery-details]'));
  }

  function getEstimateVariantId() {
    var listing = document.getElementById('d1-bundle-listing-atc-config');
    if (listing) {
      try {
        var config = JSON.parse(listing.textContent);
        if (config && config.parentVariantId > 0) return String(config.parentVariantId);
      } catch (_) {
        /* ignore */
      }
    }
    var pickup = document.querySelector('pickup-availability');
    if (pickup && pickup.dataset.variantId) return String(pickup.dataset.variantId);
    var input = document.querySelector(
      'product-form input[name="id"], form[action*="/cart/add"] input[name="id"]'
    );
    return input && input.value ? String(input.value) : '';
  }

  function getStockApiBase() {
    var pickup = document.querySelector('pickup-availability');
    var fromPickup = pickup && pickup.getAttribute('data-pickup-stock-api');
    return String(fromPickup || DEFAULT_STOCK_API).replace(/\/$/, '');
  }

  function fetchPickupLocations(variantId) {
    if (!variantId) return Promise.resolve(null);
    var api = getStockApiBase();
    if (window.__d1PickupStock && typeof window.__d1PickupStock.fetchMany === 'function') {
      return window.__d1PickupStock.fetchMany(api, [variantId]).then(function () {
        var row = window.__d1PickupStock.get(variantId);
        if (!row) return null;
        return row.locations || [];
      });
    }
    var url = api + '?variantId=' + encodeURIComponent(variantId);
    return fetch(url, { credentials: 'omit' })
      .then(function (res) {
        if (!res.ok) throw new Error('stock');
        return res.json();
      })
      .then(function (json) {
        if (json && json.success === false) return null;
        var data = json && json.data ? json.data : json;
        return (data && data.locations) || null;
      })
      .catch(function () {
        return null;
      });
  }

  function revealRows(container) {
    if (!container) return;
    var rows = container.querySelectorAll('.d1-delivery__row');
    var i;
    for (i = 0; i < rows.length; i++) rows[i].classList.add('d1-delivery__reveal');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        for (i = 0; i < rows.length; i++) rows[i].classList.add('is-in');
      });
    });
  }

  function applyDispatchOriginUi(origin) {
    var details = getDeliveryContainer();
    if (!details) return;
    var storeOrigin = origin === 'store';
    var hours = storeOrigin ? STORE_DISPATCH_HOURS : WAREHOUSE_DISPATCH_HOURS;
    details.setAttribute('data-dispatch-hours', String(hours));
    details.setAttribute('data-dispatch-origin', storeOrigin ? 'store' : 'warehouse');

    var card = details.closest('.d1-delivery') || details;
    var valueEl = card.querySelector('[data-d1-dispatch-value]');
    if (valueEl) {
      valueEl.textContent = 'Within ' + hours + ' Business Hours';
      valueEl.classList.remove('d1-delivery__reveal');
    }

    var pill = card.querySelector('[data-d1-store-origin-note]');
    if (pill) {
      if (storeOrigin) pill.removeAttribute('hidden');
      else pill.setAttribute('hidden', '');
    }

    var modalNote = document.querySelector('.pc-modal__note');
    if (modalNote) {
      modalNote.textContent = storeOrigin ? STORE_MODAL_NOTE : WAREHOUSE_MODAL_NOTE;
    }
  }

  function getCustomerAddress() {
    var el = document.querySelector('[data-d1-customer-zip]');
    if (!el) return null;
    var zip = normalizePostcode(el.value || el.getAttribute('value'));
    if (!/^\d{4}$/.test(zip)) return null;
    return {
      postcode: zip,
      city: (el.getAttribute('data-city') || '').trim(),
      province: (el.getAttribute('data-province') || '').trim()
    };
  }

  function resolvePostcode() {
    var customer = getCustomerAddress();
    var saved = normalizePostcode(localStorage.getItem('d1_postcode'));
    var manual = localStorage.getItem('d1_postcode_manual') === '1';

    if (customer && !manual) {
      return { postcode: customer.postcode, source: 'account', city: customer.city };
    }
    if (saved && /^\d{4}$/.test(saved)) {
      return { postcode: saved, source: manual ? 'manual' : 'saved', city: '' };
    }
    if (customer) {
      return { postcode: customer.postcode, source: 'account', city: customer.city };
    }
    return null;
  }

  function calculateFallback(postcode) {
    var clean = normalizePostcode(postcode);
    var zone = lookupZone(clean);
    if (!zone) return null;

    var dispatchDays = getDispatchDays();
    var now = new Date();
    var dispatchDate = addBusinessDays(now, dispatchDays);

    return {
      zone: zone.label,
      postcode: clean,
      standard: {
        from: fmtDate(addBusinessDays(dispatchDate, zone.standard[0])),
        to: fmtDate(addBusinessDays(dispatchDate, zone.standard[1]))
      },
      express: {
        from: fmtDate(addBusinessDays(dispatchDate, zone.express[0])),
        to: fmtDate(addBusinessDays(dispatchDate, zone.express[1]))
      },
      source: 'fallback'
    };
  }

  function mapApiPayload(payload) {
    if (!payload || payload.fallbackSuggested) return null;
    var standardFrom = fmtIsoDate(payload.standard && payload.standard.from);
    var standardTo = fmtIsoDate(payload.standard && payload.standard.to);
    var expressBuffered = withExpressBuffer(
      payload.express && payload.express.from,
      payload.express && payload.express.to
    );
    var expressFrom = fmtIsoDate(expressBuffered.from);
    var expressTo = fmtIsoDate(expressBuffered.to);
    if (!standardFrom && !expressFrom) return null;

    return {
      zone: payload.zoneLabel || '',
      postcode: payload.postcode,
      standard: {
        from: standardFrom || standardTo,
        to: standardTo || standardFrom
      },
      express: {
        from: expressFrom || expressTo,
        to: expressTo || expressFrom
      },
      cutoffLabel: payload.cutoffLabel || '',
      dispatchDate: payload.dispatchDate || '',
      source: 'api'
    };
  }

  function cacheKey(postcode, dispatchDays, locality) {
    return (
      CACHE_PREFIX +
      [postcode, String(dispatchDays), locality || '', cacheDayKey()].join('|')
    );
  }

  function readCache(postcode, dispatchDays, locality) {
    try {
      var raw = sessionStorage.getItem(cacheKey(postcode, dispatchDays, locality));
      if (!raw) return null;
      return mapApiPayload(JSON.parse(raw));
    } catch (e) {
      return null;
    }
  }

  function writeCache(postcode, dispatchDays, locality, payload) {
    try {
      sessionStorage.setItem(cacheKey(postcode, dispatchDays, locality), JSON.stringify(payload));
    } catch (e) {
      /* ignore quota */
    }
  }

  function fetchEta(postcode, dispatchDays, locality) {
    var clean = normalizePostcode(postcode);
    if (!/^\d{4}$/.test(clean)) {
      return Promise.resolve(null);
    }

    var cached = readCache(clean, dispatchDays, locality);
    if (cached) return Promise.resolve(cached);

    var url = new URL(getEtaApiBase(), window.location.origin);
    url.searchParams.set('postcode', clean);
    url.searchParams.set('dispatchDays', String(dispatchDays));
    if (locality) url.searchParams.set('locality', locality);

    return fetch(url.toString(), {
      method: 'GET',
      credentials: 'omit',
      headers: { Accept: 'application/json' }
    })
      .then(function (res) {
        if (!res.ok) throw new Error('eta_http_' + res.status);
        return res.json();
      })
      .then(function (body) {
        var payload = body && body.data ? body.data : body;
        var mapped = mapApiPayload(payload);
        if (mapped) writeCache(clean, dispatchDays, locality, payload);
        return mapped;
      })
      .catch(function () {
        return null;
      });
  }

  function resolveEstimate(postcode, locality) {
    var dispatchDays = getDispatchDays();
    return fetchEta(postcode, dispatchDays, locality || '').then(function (apiResult) {
      if (apiResult) return apiResult;
      return calculateFallback(postcode);
    });
  }

  function updateDeliveryDisplay(result, meta) {
    var container = getDeliveryContainer();
    if (!container) return;
    meta = meta || {};

    if (!result) {
      setResolvedPostcode(container, '');
      if (getPostcodePrompt()) {
        container.innerHTML = '';
        setDeliveryCardEta(container, false);
        return;
      }
      container.innerHTML =
        '<div class="d1-delivery__row d1-delivery__row--action" data-d1-open-postcode>' +
          '<div class="d1-delivery__icon d1-delivery__icon--location">' +
            '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>' +
          '</div>' +
          '<div class="d1-delivery__info">' +
            '<span class="d1-delivery__label">Delivery ETA & Store Locator</span>' +
            '<span class="d1-delivery__value d1-delivery__value--action">Enter postcode for estimate</span>' +
          '</div>' +
          '<span class="d1-delivery__arrow"><svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M9 18l6-6-6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></span>' +
        '</div>';
      setDeliveryCardEta(container, false);
      revealRows(container);
      return;
    }

    var zoneBits = [result.postcode];
    if (meta.city) zoneBits.push(meta.city);
    if (result.zone) zoneBits.push(result.zone);
    var sourceBadge =
      meta.source === 'account'
        ? '<span class="d1-delivery__source">Your address</span>'
        : '';

    var standardText =
      result.standard.from === result.standard.to
        ? result.standard.from
        : result.standard.from + ' \u2013 ' + result.standard.to;
    var expressText =
      result.express.from === result.express.to
        ? result.express.from
        : result.express.from + ' \u2013 ' + result.express.to;

    container.innerHTML =
      '<div class="d1-delivery__row">' +
        '<div class="d1-delivery__icon d1-delivery__icon--standard">' +
          '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="3" width="15" height="13"></rect><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon><circle cx="5.5" cy="18.5" r="2.5"></circle><circle cx="18.5" cy="18.5" r="2.5"></circle></svg>' +
        '</div>' +
        '<div class="d1-delivery__info">' +
          '<span class="d1-delivery__label">Standard (Signature Delivery)</span>' +
          '<span class="d1-delivery__value">' + standardText + '</span>' +
        '</div>' +
      '</div>' +
      '<div class="d1-delivery__row">' +
        '<div class="d1-delivery__icon d1-delivery__icon--express">' +
          '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon></svg>' +
        '</div>' +
        '<div class="d1-delivery__info">' +
          '<span class="d1-delivery__label">Express (Signature Delivery)</span>' +
          '<span class="d1-delivery__value">' + expressText + '</span>' +
        '</div>' +
      '</div>' +
      '<div class="d1-delivery__row d1-delivery__row--change" data-d1-open-postcode>' +
        '<span class="d1-delivery__zone">' +
          zoneBits.join(' \u00b7 ') +
          (sourceBadge ? ' ' + sourceBadge : '') +
          ' <span class="d1-delivery__note-inline">| Estimated - Actual Delivery Times May Vary</span>' +
        '</span>' +
        '<span class="d1-delivery__change">Change</span>' +
      '</div>';
    setResolvedPostcode(container, result.postcode);
    setDeliveryCardEta(container, true);
    revealRows(container);
  }

  // Browser location -> postcode. Coordinates are rounded (~100m) before leaving the device and are
  // only sent to OpenStreetMap Nominatim (CORS-enabled, no key). Returns null on any failure.
  // ponytail: Nominatim fair-use (user-click only) -> move behind d1x API if volume grows.
  var REVERSE_GEOCODE_URL = 'https://nominatim.openstreetmap.org/reverse';
  var REVERSE_GEOCODE_TIMEOUT_MS = 6000;
  var GEOLOCATION_TIMEOUT_MS = 10000;
  var GEOLOCATION_MAX_AGE_MS = 10 * 60 * 1000;

  function postcodeFromReverseGeocode(data) {
    var address = data && data.address;
    if (!address || String(address.country_code).toLowerCase() !== 'au') return null;
    var postcode = normalizePostcode(address.postcode);
    return /^\d{4}$/.test(postcode) ? postcode : null;
  }

  function getBrowserPosition() {
    return new Promise(function (resolve) {
      navigator.geolocation.getCurrentPosition(
        function (pos) { resolve(pos && pos.coords ? pos.coords : null); },
        function () { resolve(null); },
        { enableHighAccuracy: false, timeout: GEOLOCATION_TIMEOUT_MS, maximumAge: GEOLOCATION_MAX_AGE_MS }
      );
    });
  }

  function locatePostcode() {
    if (!navigator.geolocation) return Promise.resolve(null);
    return getBrowserPosition().then(function (coords) {
      if (!coords) return null;
      var url = new URL(REVERSE_GEOCODE_URL);
      url.searchParams.set('format', 'jsonv2');
      url.searchParams.set('lat', coords.latitude.toFixed(3));
      url.searchParams.set('lon', coords.longitude.toFixed(3));
      url.searchParams.set('zoom', '18');
      url.searchParams.set('addressdetails', '1');
      var ctrl = new AbortController();
      var timer = setTimeout(function () { ctrl.abort(); }, REVERSE_GEOCODE_TIMEOUT_MS);
      return fetch(url.toString(), {
        credentials: 'omit',
        headers: { Accept: 'application/json' },
        signal: ctrl.signal
      })
        .then(function (res) { return res.ok ? res.json() : null; })
        .then(postcodeFromReverseGeocode)
        .catch(function () { return null; })
        .then(function (postcode) {
          clearTimeout(timer);
          return postcode;
        });
    });
  }

  function initModal() {
    var modal = document.getElementById('PostcodeModal');
    if (!modal) return;
    if (modal === boundModal) return;
    if (modalAbortController) modalAbortController.abort();
    modalAbortController = new AbortController();
    var signal = modalAbortController.signal;
    boundModal = modal;

    var input = modal.querySelector('[data-postcode-input]');
    var checkBtn = modal.querySelector('[data-postcode-check]');
    var locateBtn = modal.querySelector('[data-postcode-locate]');
    var errorEl = modal.querySelector('[data-postcode-error]');
    var closeBtns = modal.querySelectorAll('[data-postcode-close]');
    var resultEl = modal.querySelector('[data-postcode-result]');

    function openModal() {
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      var resolved = resolvePostcode();
      if (input && resolved && resolved.postcode) {
        input.value = resolved.postcode;
      }
      setTimeout(function () { if (input) input.focus(); }, 100);
    }

    function closeModal() {
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (errorEl) errorEl.textContent = '';
      if (resultEl) resultEl.hidden = true;
    }

    closeBtns.forEach(function (btn) {
      btn.addEventListener('click', closeModal, { signal: signal });
    });

    modal.addEventListener('keyup', function (e) {
      if (e.key === 'Escape') closeModal();
    }, { signal: signal });

    if (input) {
      input.addEventListener('keyup', function (e) {
        if (e.key === 'Enter') checkBtn.click();
      }, { signal: signal });
    }

    function submitPostcode(val) {
      var requestModal = modal;
      if (checkBtn) checkBtn.disabled = true;
      if (locateBtn) locateBtn.disabled = true;
      return resolveEstimate(val, '').then(function (result) {
        if (requestModal !== boundModal) return;
        if (checkBtn) checkBtn.disabled = false;
        if (locateBtn) locateBtn.disabled = false;
        if (!result) {
          errorEl.textContent = 'We couldn\u2019t find delivery estimates for that postcode';
          return;
        }
        errorEl.textContent = '';
        localStorage.setItem('d1_postcode', val);
        localStorage.setItem('d1_postcode_manual', '1');
        try {
          window.dispatchEvent(new CustomEvent('d1:postcode-changed', { detail: { postcode: val } }));
        } catch (err) {}
        updateDeliveryDisplay(result, { source: 'manual', city: '' });
        closeModal();
      });
    }

    if (checkBtn) {
      checkBtn.addEventListener('click', function () {
        var val = normalizePostcode(input ? input.value : '');
        if (!/^\d{4}$/.test(val)) {
          errorEl.textContent = 'Please enter a valid 4-digit Australian postcode';
          return;
        }
        submitPostcode(val);
      }, { signal: signal });
    }

    if (locateBtn) {
      if (!navigator.geolocation) {
        locateBtn.hidden = true;
      } else {
        locateBtn.addEventListener('click', function () {
          var label = locateBtn.querySelector('[data-postcode-locate-label]');
          var idleText = label ? label.textContent : '';
          errorEl.textContent = '';
          locateBtn.disabled = true;
          if (label) label.textContent = 'Locating\u2026';
          locatePostcode().then(function (postcode) {
            if (label) label.textContent = idleText;
            locateBtn.disabled = false;
            if (!postcode) {
              errorEl.textContent = 'We couldn\u2019t detect your postcode. Please enter it above.';
              return;
            }
            if (input) input.value = postcode;
            submitPostcode(postcode);
          });
        }, { signal: signal });
      }
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-d1-open-postcode]')) {
        openModal();
      }
    }, { signal: signal });

    return openModal;
  }

  function init() {
    var generation = ++initGeneration;
    initModal();

    function refreshDisplay() {
      // Pre-order variants use metafield messaging (ship date / message) — no ETA rows.
      if (isPreorderDeliveryActive() || !getDeliveryContainer()) return;
      var resolved = resolvePostcode();
      if (!resolved) {
        updateDeliveryDisplay(null);
        return;
      }
      resolveEstimate(resolved.postcode, resolved.city).then(function (result) {
        if (generation !== initGeneration) return;
        if (isPreorderDeliveryActive() || !getDeliveryContainer()) return;
        updateDeliveryDisplay(result, resolved);
      });
    }

    function applyOriginThenRefresh() {
      if (isPreorderDeliveryActive()) {
        refreshDisplay();
        return;
      }
      if (!canApplyStoreOrigin()) {
        applyDispatchOriginUi('warehouse');
        refreshDisplay();
        return;
      }
      fetchPickupLocations(getEstimateVariantId()).then(function (locations) {
        if (generation !== initGeneration) return;
        if (isPreorderDeliveryActive() || !canApplyStoreOrigin()) {
          refreshDisplay();
          return;
        }
        var origin = classifyDispatchOrigin(locations);
        applyDispatchOriginUi(origin === 'store' ? 'store' : 'warehouse');
        refreshDisplay();
      });
    }

    applyOriginThenRefresh();

    if (inventoryObserver) inventoryObserver.disconnect();
    inventoryObserver = null;
    // Only watch inventory class changes for in-stock ETA dispatch timing — skip on preorder.
    var wrapper = document.querySelector('.product__inventory-wrapper');
    if (wrapper && wrapper.getAttribute('data-preorder') !== 'true') {
      var timeout;
      inventoryObserver = new MutationObserver(function () {
        if (isPreorderDeliveryActive()) return;
        clearTimeout(timeout);
        timeout = setTimeout(refreshDisplay, 120);
      });
      inventoryObserver.observe(wrapper, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'data-preorder'],
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('product-info:loaded', init);

  window.d1DeliveryEstimate = {
    calculate: calculateFallback,
    calculateFallback: calculateFallback,
    resolveEstimate: resolveEstimate,
    updateDisplay: updateDeliveryDisplay,
    classifyDispatchOrigin: classifyDispatchOrigin,
    dispatchDaysFromHours: dispatchDaysFromHours,
    postcodeFromReverseGeocode: postcodeFromReverseGeocode
  };
})();
